(function () {
  let _skipNextClick = false;
  let _redirectAfterAdd = false;

  // Detect if we are on the kaching bundle page
  const _cartDrawerOnlyPages = ['custom_bundle_page', 'bundle-sub-v21', 'bundle-sub-v20', 'bundle-sub-v16-dtc', 'bundle-v16' ,'bundle-sub-v16'];
  function isKachingPage() {
    if (_cartDrawerOnlyPages.some(cls => document.body.classList.contains(cls))) return false;
    return window.location.search.includes('v18') ||
      window.location.search.includes('elevate') ||
      window.location.pathname.includes('for-bundle');
  }

  // Step 1: Intercept click → clear cart → re-fire for third-party app to handle
  document.addEventListener('click', async function (e) {
    if (_skipNextClick) {
      _skipNextClick = false;
      return;
    }

    const btn = e.target.closest('.product-form__submit');
    if (!btn) return;

    // Only intercept on kaching bundle page
    if (!isKachingPage()) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (_) { }

    _redirectAfterAdd = true;
    _skipNextClick = true;
    btn.click();
  }, true);

  // Step 2: After /cart/add.js succeeds on kaching page → go to /checkout
  const _origFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await _origFetch.apply(this, args);

    if (_redirectAfterAdd) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      if (url.includes('/cart/add')) {
        _redirectAfterAdd = false;
        if (response.ok) {
          window.location.href = '/checkout';
        }
      }
    }

    return response;
  };
})();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const selling_plan = document.querySelector(".js_variant_change.active[data-plan-id]");
        if (selling_plan) {
          formData.append('selling_plan', selling_plan.getAttribute("data-plan-id"));
        }

        config.body = formData;

        var is_bundle = false;
        if (document.querySelector("body").classList.contains('bundle-v2') ||
          document.querySelector("body").classList.contains('bundle-v4') ||
          document.querySelector("body").classList.contains('bundle-v5') ||
          document.querySelector("body").classList.contains('bundle-v6') ||
          document.querySelector("body").classList.contains('bundle-v7') ||
          document.querySelector("body").classList.contains('bundle-v8') ||
          document.querySelector("body").classList.contains('bundle-subscription') ||
          document.querySelector("body").classList.contains('offer') ||
          document.querySelector("body").classList.contains('bundle-sub-2step')) is_bundle = true;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (response.status === 429) {
              this.show429Error();
              throw { _429: true };
            }
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (is_bundle) { //CD [addtocart tracking]
                let discount = '';
                if (document.querySelector('.atc_subscription')) {
                  let free_gift = document.querySelectorAll(".single_gift.active[free-gift-var-id]");
                  if (free_gift.length == 2) {
                    discount = '?discount=GET2FREE';
                  } else if (free_gift.length == 1) {
                    discount = '?discount=GET1FREE';
                  }
                }
                location.href = "/checkout" + discount;

                const add_subscription = document.querySelector(".js_add_bundle");
                if (add_subscription) add_subscription.classList.remove("loading");

              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            if (!e?._429) console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.remove('hidden');
          });
      }

      show429Error() {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        if (this.errorMessage) {
          this.errorMessage.innerHTML =
            'Too many requests — <button type="button" onclick="location.href=\'/cart/clear?return_to=\'+encodeURIComponent(location.pathname+location.search)" style="text-decoration:underline;background:none;border:none;padding:0;cursor:pointer;font:inherit;color:inherit;">reload the page</button> and try again.';
        }
        this.errorMessageWrapper.removeAttribute('hidden');
        this.errorMessageWrapper.style.color = '#cc0000';
        this.error = true;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        this.errorMessageWrapper.style.color = '';

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
